<template>
  <b-navbar toggleable type="light" variant="faded" toggle-breakpoint="md">

    <b-nav-toggle target="nav_collapse"></b-nav-toggle>

    <b-collapse is-nav id="nav_collapse">

      <b-nav is-nav-bar>
        <b-nav-item :to="{ name: 'Hello'}">Home</b-nav-item>
        <b-nav-item href="#">Illustrations</b-nav-item>
        <b-nav-item href="#">Editions</b-nav-item>
        <b-nav-item :to="{ name: 'Copies'}">Copies</b-nav-item>
      </b-nav>

      <!-- Right alignd nav items -->
      <b-nav is-nav-bar class="ml-auto">


        <b-nav-item-dropdown text="Admin" right>
          <b-dropdown-item :to="{ name: 'AdminIllustrations'}">Illustrations</b-dropdown-item>
          <b-dropdown-item :to="{ name: 'AdminCopies'}">Copies</b-dropdown-item>
        </b-nav-item-dropdown>

        <b-nav-form>
          <b-form-input size="sm" class="mr-sm-2" type="text" placeholder="Search"/>
          <b-button size="sm" class="my-2 my-sm-0" type="submit">Search</b-button>
        </b-nav-form>


      </b-nav>

    </b-collapse>
  </b-navbar>

</template>

<script>
export default {
  name: 'navbar',
  data () {
    return {
        page : "home"
    }
  },
  methods: {
    logout: function() {
      window.localStorage.setItem('authUser', null);
      this.$router.push({ name: "Hello" });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// navbar.vue?60a6c36b